<div class="alert alert-light py-3 px-4 mt-3" [ngClass]="{'d-none': !trendAllResults && type === 'fiveStarsQuestionResultItem'}">
    @switch(type){
        @case('closedQuestionResultItem'){
            <p>{{ 'trend_average_graph_legend_percentage_closed_desc1' | translate}}</p>
        }
        @case('scaleQuestionResultItem'){
            <p>{{'trend_all_team_average_graph_legend.scale_desc1' | translate}} <b>{{orderedValues[4]?.label}}</b> {{'trend_all_team_average_graph_legend.scale_desc2' | translate}} <b>{{orderedValues[0]?.label}}</b> (5).</p>
        }
        @case('agreeDisagreeQuestionResultItem'){
            <p>{{'trend_all_team_average_graph_legend.scale_desc1' | translate}} <b>{{orderedValues[4]?.label}}</b> {{'trend_all_team_average_graph_legend.scale_desc2' | translate}} <b>{{orderedValues[0]?.label}}</b> (5).</p>
        }
        @case('fiveStarsQuestionResultItem'){
            @if(trendAllResults){
                <p>{{'trend_average_graph_legend_percentage.five_stars_desc1' | translate}}</p>
            }
        }
    } 

    <!-- Trend chart legend supp info -->
    @if(trendAllResults){
        <p>{{ 'poll_results.trends_desc1' | translate }} <b>{{trendAllResults.recurrenceType | translate }} ({{trendAllResults.dates.length}} {{ 'poll_results.trends_desc2' | translate }})</b>.</p>
    
        @if(nullSeries > 0){
            <p>{{'poll_results.trends_desc.no_data' | translate: {nullSeries: nullSeries} }}</p>   
        }
    }

</div>